import { Stack } from "expo-router";
import { useUnistyles } from "react-native-unistyles";

export default function SiteAlarmSettingsLayout() {
  const { theme } = useUnistyles();

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <Stack
        screenOptions={{
          headerStyle: {
            backgroundColor: theme.colors.background,
          },
          headerTintColor: theme.colors.text,
          headerBackButtonDisplayMode: "minimal",
          contentStyle: {
            backgroundColor: theme.colors.background,
          },
        }}
      />
    </>
  );
}
